import { ApiProperty } from '@nestjs/swagger';
import { IsEmail, IsNotEmpty, IsOptional, ValidateIf } from 'class-validator';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Countries } from '../countries/countries.entity';
import { OcaenFreightRatesEntity } from '../ocaen-freights-rates/ocean-freights-entity';

@Entity('destination')
export class Destination {
  
  @PrimaryGeneratedColumn("increment",{name:'destination_id'})
  destinationId:number;
  
  @Column("varchar",{
    nullable: true,
    length:40,
    name:"destination_name"
    })
  // @Index({unique:true})
  destinationName:string;
 @Column("int",{
   nullable: true,
   name:"country_id"
   })
  // @Index({unique:false})
  countryId:number;
  @Column("boolean",{
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;
  
  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type=>Countries, Countries=>Countries.DestinationsInfo,{  nullable:false, })
  @JoinColumn({ name:"country_id"})
  CountriesInfo: Countries;
  @OneToMany(type => OcaenFreightRatesEntity, info => info.destinationInfo, { cascade: true })
  ocaenFreightsInfo: OcaenFreightRatesEntity[];

  }
